import { useEffect } from 'react';

/**
 * DURING FIELD 配下ページ共通の scroll fade-up 演出フック。
 *
 * 主要セレクタを自動的に .df-fade-up にマーキングし、
 * IntersectionObserver で可視範囲に入ったタイミングで .is-visible を付与する。
 *
 * 追加のセレクタを渡したい場合は引数にカンマ区切り文字列で渡す。
 */
export default function useDfFadeUp(extraSelectors = '') {
  useEffect(() => {
    // hero / page-title に流れる光のビームを挿入
    const beamHosts = document.querySelectorAll('.df-hero, .df-page-title');
    beamHosts.forEach((el) => {
      if (!el.querySelector('.df-light-beam')) {
        const beam = document.createElement('div');
        beam.className = 'df-light-beam';
        el.prepend(beam);
      }
    });

    const baseSelectors = [
      '.df-page-title',
      '.df-section',
      '.df-greeting', '.df-business', '.df-works', '.df-company-info', '.df-contact',
      '.df-business-list li', '.df-gallery li',
      '.df-greeting-image', '.df-greeting-text',
      '.df-company-table tr',
      '.df-contact-info-box',
      '.df-business-detail', '.df-works-main-image',
    ];
    const all = extraSelectors
      ? baseSelectors.concat(extraSelectors.split(',').map((s) => s.trim()))
      : baseSelectors;
    const targets = document.querySelectorAll(all.join(', '));
    targets.forEach((el) => el.classList.add('df-fade-up'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [extraSelectors]);
}
